<template>
<div class="Account">
    <div class="Account-box">
        <div class="Account-bt">账号设置</div>
        <div class="Account-boxlist">
            <div class="a-b-l">
                <div class="block">
                    <el-upload ref="upload" accept=".jpg,.png,.jpeg" :data="datasign" class="avatar-uploader" action="https://ai-write.oss-cn-hangzhou.aliyuncs.com" :show-file-list="false" :limit="1" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                        <img :src="userinfo.avatarUrl" class="avatar">
                    </el-upload>
                </div>
                <div class="user-box-vip" v-show="!userinfo.isVip">未开通会员<span @click="goVip">开通</span></div>
                <div class="user-box-vip" v-show="userinfo.isVip">{{expireTime}}日到期<span @click="goVip">续费</span></div>
            </div>
            <div class="a-b-r">
                <div class="a-b-r-box"><span>用户名</span>{{userinfo.username}}</div>
                <div class="a-b-r-box">
                    <span>昵称</span>
                    <div v-show="isUserName" style="display: inline-block;width: 79%;">
                        <span style="width: 63%;">{{userinfo.nickname}}</span>
                        <span class="b-r-box-btn" @click="ModifyUser">修改</span>
                    </div>
                    <div v-show="!isUserName" style="display: inline-block;width: 79%; position: relative;">
                        <el-input style="width: 63%;" placeholder="请输入昵称" v-model="userinfo.nickname" clearable>
                        </el-input>
                        <span style="color: #FF5959;font-size: 12px;margin-top: 5px;position: absolute;left: 0;bottom: -30px;" v-show="nameMessage !='' ">*{{nameMessage}}</span>
                        <span class="b-r-box-btn" style="width: 60px;" @click="ModifyUserFh">取消</span>
                        <span class="b-r-box-btn" style="width: 60px;" @click="ModifyUserQr">确认</span>
                    </div>
                </div>
                <div class="a-b-r-box">
                    <span>手机号</span>
                    <span class="b-r-b-z">{{userinfo.mobile}}</span>
                    <span class="b-r-box-btn" @click="modifyMobile">编辑</span>
                </div>
                <div class="a-b-r-box">
                    <span>微信</span>
                    <span class="b-r-b-z">{{userinfo.wechatName || "未绑定"}}</span>
                    <span class="b-r-box-btn" @click="bindwx" v-show="!userinfo.bindWechat">绑定</span>
                    <span class="b-r-box-btn" @click="unbindwx" v-show="userinfo.bindWechat">解绑</span>
                </div>
                <!-- <div class="a-b-r-box">
            <span>QQ</span>
            <span class="b-r-b-z">{{userinfo.qqName || "未绑定"}}</span>
            <span class="b-r-box-btn">绑定</span>
          </div> -->
                <div class="a-b-r-btn" @click="offUser">注销账号</div>
            </div>
        </div>
    </div>

    <!-- 旧手机号验证弹窗 -->
    <el-dialog :visible.sync="mobeildialog" width="30%">
        <div class="modifyM-box">
            <div class="modifyM-box-xbt">{{oldMobeilXbt}}</div>
            <p class="modifyM-box-txt">将给{{userinfo.mobile}}发送验证码进行验证</p>
            <div class="modifyBox-list">
                <el-input type="text" placeholder="请输入短信验证码" v-model="verifyCode" autocomplete="no" class="login_input"></el-input>
                <button type="button" class="obtain" :disabled="disabled" @click="obtainCode" :style="disabled ? 'color:#999' : ''">
                    {{ disabled ? time + "s后重新发送" : "发送验证码" }}
                </button>
            </div>
            <p style="color: #FF5959;font-size: 12px;margin-top: 5px;" v-show="errMessage !='' ">*{{errMessage}}</p>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="mobeildialog = false">取 消</el-button>
            <el-button type="primary" @click="subValidation">{{oldMobeilBtn}}</el-button>
        </span>
    </el-dialog>
    <!-- 换绑手机号弹窗 -->
    <el-dialog :visible.sync="mobeilsdialog" width="30%">
        <div class="modifyM-box">
            <div class="modifyM-box-xbt">换绑新手机号</div>
            <el-form :model="ruleForm" :status-icon="false" :rules="rules" ref="ruleForm" label-width="100px" label-position="top" class="demo-ruleForm">
                <el-form-item label="输入手机号" prop="mobile">
                    <el-input type="text" placeholder="请输入手机号" v-model="ruleForm.mobile" autocomplete="off" class="login_input"></el-input>
                </el-form-item>
                <el-form-item label="输入验证码" prop="verifyCode">
                    <el-input type="text" placeholder="请输入短信验证码" v-model="ruleForm.verifyCode" autocomplete="no" class="login_input"></el-input>
                    <button type="button" class="obtain" :disabled="disabledx" @click="obtainCodex" :style="disabledx ? 'color:#999' : ''">
                        {{ disabledx ? timex + "s后重新发送" : "发送验证码" }}
                    </button>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="mobeilsdialog = false">取 消</el-button>
            <el-button type="primary" @click="subValidations('ruleForm')">提交验证</el-button>
        </span>
    </el-dialog>

    <!-- 状态弹窗 -->
    <el-dialog :visible.sync="statePop" width="30%" center>
        <div class="modifyM-box statePop-box" style="text-align: center;">
            <img :src="stateImg" alt="" style="margin-bottom: 20px;">
            <p>{{stateTxt}}</p>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="statePop = false">我知道了</el-button>
        </span>
    </el-dialog>

    <!-- 注销弹窗状态 -->
    <el-dialog :visible.sync="cancellationPop" width="30%" center :before-close="cancellationClose">
        <div class="modifyM-box statePop-box" style="text-align: center;">
            <img :src="stateImg" alt="" style="margin-bottom: 20px;">
            <p>{{stateTxt}}</p>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="gotohome">我知道了</el-button>
        </span>
    </el-dialog>

    <!-- 绑定微信弹窗 -->
    <el-dialog :visible.sync="wxBindPop" width="30%" center :before-close="wxBindClose">
        <div class="modifyM-box" style="text-align: center;">
            <div class="modifyM-box-xbt">绑定微信</div>
            <div class="ercode" id="ercode" v-loading="loading" @click="bindwx">
                <img :src="wxcodeImg">
            </div>
            <p>微信扫一扫二维码完成绑定</p>
        </div>
    </el-dialog>

    <!-- 解绑微信弹窗 -->
    <el-dialog :visible.sync="wxunbindPop" width="30%" center>
        <div class="modifyM-box" style="text-align: center;">
            <div class="modifyM-box-xbt">{{unbindPopXbt}}</div>
            <p>{{unbindPopTxt}}</p>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="wxunbindPop = false">取 消</el-button>
            <el-button type="primary" @click="subunbindwx">{{unbindPopBtn}}</el-button>
        </span>
    </el-dialog>

    <!-- 客服 -->
    <!-- <div class="kf-iconr" @click="iskf">
        <img src="../../../static/images/zhanghu_kefu.png" alt="">
        <span>客服</span>
    </div> -->
    <!-- 打开客服框 -->
    <!-- <div class="kf-box" v-show="iskfBox">
        <div class="kf-close" @click="iskfBox = false" style="text-align: right;cursor: pointer;"><i class="el-icon-close" style="font-size: 20px;"></i></div>
        <div class="kf-box-xbt">意见反馈</div>
        <div class="kf-box-z">在线咨询：<img src="../../../static/images/vip_erweima.png" alt=""><span>客服微信</span>
            <img :src="contactList.wxUrl" alt="" class="wxImg">
        </div>
        <div class="kf-box-z">欢迎留言吐槽：</div>
        <div class="kf-box-inp"> -->
    <!-- 留言框 -->
    <!-- <el-input type="textarea" :rows="6" placeholder="请输入反馈内容，内容不要超过500字..." v-model="fkParams.content" class="fk-con">
            </el-input> -->
    <!-- 上传图片 -->
    <!-- <div class="kf-imgs">
                <el-upload ref="upload" accept=".jpg,.png,.jpeg" :data="feedbackData" action="https://ai-write.oss-cn-hangzhou.aliyuncs.com" :show-file-list="false" :limit="1" :on-success="feedbackSuccess" :before-upload="feedbackUpload">
                    <el-input readonly class="fk-con" v-model="fkParams.images"></el-input>
                    <img src="../../../static/images/zhanghu_tupian.png" alt="">
                </el-upload>
            </div>
        </div>
        <el-input v-model="fkParams.contact" placeholder="您的邮箱或者QQ号"></el-input>
        <div class="kf-zy">注：客服小姐姐收到留言后会根据邮箱或者QQ联系您</div>
        <div class="kf-btn" @click="feedback">发送</div>
    </div> -->

</div>
</template>

<script>
export default {
    data() {
        return {
            businessType: 4,
            // 用户信息
            userinfo: {},
            avatarUrl: '',
            // 修改昵称
            nameMessage: '',
            // vip到期时间
            expireTime: '',
            isUserName: true,
            // 头像上传附加参数
            datasign: {},
            // 验证旧手机弹窗
            disabled: false,
            codeTime: '',
            time: 60,
            mobeildialog: false,
            verifyCode: '',
            oldMobeil: '',
            errMessage: '',
            oldMobeilXbt: '',
            oldMobeilBtn: '',

            // 更换手机号
            disabledx: false,
            phonetime: '',
            timex: 60,
            mobeilsdialog: false,
            ruleForm: {
                mobile: '',
                userId: '',
                verifyCode: ''
            },
            rules: {},

            // 状态弹窗
            statePop: false,
            stateImg: '',
            stateTxt: '',

            // 注销状态
            cancellationPop: false,

            // 绑定微信
            wxBindPop: false,
            wxbindParams: {
                oper: 'wx_bind_ticket'
            },
            wxcodeImg: '',
            wxcodeData: {},
            // 二维码轮询
            _v_t_i: '',
            loading: true,

            // 解绑微信
            wxunbindPop: false,
            unbindPopXbt: '',
            unbindPopTxt: '',
            unbindPopBtn: '',

            // 反馈意见
            fkParams: {
                category: 4, // 用户反馈类型
                contact: '', // 联系方式
                content: '', // 反馈内容
                images: '', // 图片（地址）
                terminal: 1, // 反馈终端
                userId: '' // 用户id
            },
            iskfBox: false, // 是否打开客服框
            feedbackData: {}, // 上传图片时额外参数（图片的信息）

            contactList: {}

        }
    },
    created() {
        this.userinfo = JSON.parse(localStorage.getItem('userinfo'))
        if (this.userinfo.expireTime != null) {
            this.expireTime = this.userinfo.expireTime.split(' ')[0]
        }

        this.getContact()

        // 验证旧手机号倒计时
        if (localStorage.getItem('codetime')) {
            var code_time = localStorage.getItem('codetime')
            this.time = code_time - Math.round(new Date().getTime() / 1000)
            if (this.time > 0) {
                this.disabled = true
            }
            this.codeTime = setInterval(() => {
                if (this.time <= 0) {
                    this.disabled = false
                    clearInterval(this.codeTime)
                    localStorage.removeItem('codetime')
                }
                this.time = code_time - Math.round(new Date().getTime() / 1000)
            }, 1000)
        }

        // 更换手机号倒计时
        if (localStorage.getItem('phonetime')) {
            var code_timex = localStorage.getItem('phonetime')
            this.timex = code_timex - Math.round(new Date().getTime() / 1000)
            if (this.timex > 0) {
                this.disabledx = true
            }
            this.phonetime = setInterval(() => {
                if (this.timex <= 0) {
                    this.disabledx = false
                    clearInterval(this.phonetime)
                    localStorage.clear('phonetime')
                }
                this.timex = code_timex - Math.round(new Date().getTime() / 1000)
            }, 1000)
        }
    },
    methods: {
        // 头像
        handleAvatarSuccess(response, file, fileList) {
            this.$message({
                message: '上传成功',
                type: 'success'
            })
        },
        async beforeAvatarUpload(file) {
            const isLt50K = file.size / 1024 / 1024 < 0.05
            if (!isLt50K) {
                this.$message.error('上传头像图片大小不能超过 50K!')
            } else {
                let picSuffix = {
                    picSuffix: file.name.split('.')[1]
                }
                await this.api.upload(picSuffix).then(res => {
                    this.datasign.ossid = res.data.ossid
                    this.datasign.key = res.data.ossKey
                    this.datasign.policy = res.data.policy
                    this.datasign.ossAccessKeyId = res.data.ossAccessKeyId
                    this.datasign.signature = res.data.signature
                    this.userinfo.avatarUrl = res.data.ossurl + '/' + res.data.ossKey
                })
                this.api.modefyUser(this.userinfo).then(res => {
                    if (res.code == 0) {
                        localStorage.setItem('userinfo', JSON.stringify(this.userinfo))
                        location.reload()
                    }
                })
            }
            return isLt50K
        },

        // 修改昵称
        ModifyUser() {
            this.isUserName = false
        },
        // 取消
        ModifyUserFh() {
            this.isUserName = true
            // 清除提示
            this.nameMessage = ''
            this.userinfo = JSON.parse(localStorage.getItem('userinfo'))
        },
        // 确认
        ModifyUserQr() {
            if (this.userinfo.nickname == '' || this.userinfo.wechatName == '' || this.userinfo.qqName == '') {
                this.nameMessage = '昵称不能为空'
            } else {
                this.api.modefyUser(this.userinfo).then(res => {
                    if (res.code == 0) {
                        this.isUserName = true
                        this.$message.success('修改成功')
                        localStorage.setItem('userinfo', JSON.stringify(this.userinfo))
                    }
                })
            }
        },

        // 修改手机号
        modifyMobile() {
            this.businessType = 4
            this.oldMobeilXbt = '手机安全验证'
            this.oldMobeilBtn = '提交验证'
            this.mobeildialog = true
            this.errMessage = ''
        },
        // 发送验证码
        obtainCode() {
            this.oauthapi.accsend({
                businessType: this.businessType
            }).then(res => {
                if (res.code == 0) {
                    this.disabled = true
                    var time = new Date().getTime() / 1000
                    var code_time = 0
                    this.time = 60
                    if (!localStorage.getItem('codetime')) {
                        code_time = Math.round(time) + 60
                        localStorage.setItem('codetime', code_time)
                        this.codeTime = setInterval(() => {
                            if (this.time <= 0) {
                                localStorage.removeItem('codetime')
                                clearInterval(this.codeTime)
                                this.disabled = false
                            }
                            this.time = code_time - Math.round(new Date() / 1000)
                        }, 1000)
                    } else {
                        code_time = localStorage.getItem('codetime')
                        this.codeTime = setInterval(() => {
                            if (this.time <= 0) {
                                localStorage.removeItem('codetime')
                                clearInterval(this.codeTime)
                                this.disabled = false
                            }
                            this.time = code_time - Math.round(new Date() / 1000)
                        }, 1000)
                    }
                } else {
                    this.errMessage = res.msg
                }
            })
        },
        // 旧手机号提交验证
        subValidation() {

            if (this.oldMobeilBtn == '提交验证') {
                if (this.verifyCode == '') {
                    this.errMessage = '请输入验证码'
                } else {
                    let reform = {
                        verifyCode: this.verifyCode,
                        userId: localStorage.getItem('userId')
                    }
                    console.log(reform)
                    this.api.mobileold(reform).then(res => {
                        if (res.code == 0) {
                            this.$message.success(res.data)
                            this.ruleForm.verifyCode = ''
                            this.ruleForm.mobile = ''
                            this.mobeildialog = false
                            this.mobeilsdialog = true
                        } else {
                            this.errMessage = res.msg
                        }
                    })
                }
            } else if (this.oldMobeilBtn == '验证账号') {
                if (this.verifyCode == '') {
                    this.errMessage = '请输入验证码'
                } else {
                    this.ruleForm.verifyCode = this.verifyCode
                    this.ruleForm.userId = localStorage.getItem('userId')
                    console.log(this.ruleForm)
                    this.oauthapi.offUser({
                        verifyCode: this.verifyCode
                    }).then(res => {
                        if (res.code == 0) {
                            this.mobeildialog = false
                            this.stateImg = '../../../static/images/acc_state_sucess.png'
                            this.stateTxt = '注销成功，您将退出登录'
                            this.statePop = true
                            localStorage.clear()
                            setTimeout(() => {
                                this.$router.replace({
                                    path: '/home'
                                })
                            }, 1000);

                        } else {
                            this.errMessage = res.msg
                        }
                    })
                }
            }
        },

        // 点击我知道了
        gotohome() {
            this.cancellationPop = false
            this.$router.push('/')
            location.reload()
        },
        // 点击关闭
        cancellationClose(done) {
            done()
            this.$router.push('/')
            location.reload()
        },

        // 新手机号发送验证码
        obtainCodex() {
            this.rules = {
                mobile: [{
                    validator: (rule, value, callback) => {
                        if (value == '') {
                            callback(new Error('*请输入手机号'))
                        } else if (!/^1[3456789]\d{9}$/.test(value)) {
                            callback(new Error('*手机号格式不正确，请重新输入'))
                        } else {
                            let sendData = {
                                businessType: 3,
                                mobile: this.ruleForm.mobile
                            }
                            this.oauthapi.send(sendData).then(res => {
                                if (res.code == 0) {
                                    this.disabledx = true
                                    var timex = new Date().getTime() / 1000
                                    var code_timex = 0
                                    this.timex = 60
                                    if (!localStorage.getItem('phonetime')) {
                                        code_timex = Math.round(timex) + 60
                                        localStorage.setItem('phonetime', code_timex)
                                        this.phonetime = setInterval(() => {
                                            if (this.timex <= 0) {
                                                localStorage.clear('phonetime')
                                                clearInterval(this.phonetime)
                                                this.disabledx = false
                                            }
                                            this.timex = code_timex - Math.round(new Date() / 1000)
                                        }, 1000)
                                    } else {
                                        code_timex = localStorage.getItem('phonetime')
                                        this.phonetime = setInterval(() => {
                                            if (this.timex <= 0) {
                                                localStorage.clear('phonetime')
                                                clearInterval(this.phonetime)
                                                this.disabledx = false
                                            }
                                            this.timex = code_timex - Math.round(new Date() / 1000)
                                        }, 1000)
                                    }
                                } else if (res.code == 1012) {
                                    this.$message.error(res.msg)
                                } else if (res.code == 2002) {
                                    this.statePop = true
                                    this.stateImg = '../../../static/images/acc_state_win.png'
                                    this.stateTxt = res.msg
                                }
                            })
                        }
                    },
                    trigger: 'blur'
                }]
            }
        },

        // 新手机号提交验证
        subValidations(formName) {
            this.rules = {
                mobile: [{
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error('*请输入手机号'))
                        } else if (!/^1[3456789]\d{9}$/.test(value)) {
                            callback(new Error('*手机号格式不正确，请重新输入'))
                        } else {
                            callback()
                        }
                    },
                    trigger: 'blur'
                }],
                verifyCode: [{
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error('*输入验证码'))
                        } else {
                            this.ruleForm.userId = localStorage.getItem('userId')
                            this.oauthapi.changemobile(this.ruleForm).then(res => {
                                if (res.code == 0) {
                                    this.mobeilsdialog = false
                                    this.statePop = true
                                    this.stateImg = '../../../static/images/acc_state_sucess.png'
                                    this.stateTxt = res.msg
                                    // 更新用户信息
                                    this.oauthapi.userInfo().then(res => {
                                        localStorage.setItem('userinfo', JSON.stringify(res.data))
                                        this.userinfo = res.data
                                    })
                                }
                            })
                        }
                    },
                    trigger: 'blur'
                }]
            }
        },

        goVip() {
            let routeUrl = this.$router.resolve({
                path: '/page/vip'
            })
            window.open(routeUrl.href, '_blank')
        },

        // 绑定微信
        bindwx() {
            this.wxBindPop = true
            this.oauthapi.isbindwechat(this.wxbindParams).then(res => {
                if (res.code == 0) {
                    this.loading = false
                    this.wxcodeData = res.data
                    this.wxcodeImg = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + res.data.returnUrl
                    var that = this
                    // 二维码轮询
                    that._v_t_i = setTimeout(function () {
                        that.iswxcode()
                    }, 3000)
                    // 90秒后二维码失效
                    setTimeout(function () {
                        that.wxcodeImg = '../../../static/images/qrcode_invalid.jpg'
                        clearTimeout(that._v_t_i)
                    }, 90000)
                } else if (res.code == -1) {
                    var that = this
                    // 服务器错误2秒后失效
                    setTimeout(function () {
                        that.loading = false
                        that.wxcodeImg = '../../../static/images/qrcode_invalid.jpg'
                        clearTimeout(that._v_t_i)
                    }, 2000)
                }
            })
        },
        // 判断二维码轮询
        iswxcode() {
            this.wxbindParams.oper = 'wx_bind_verify'
            this.wxbindParams.bind_s = this.wxcodeData.extra
            this.oauthapi.bindwechat(this.wxbindParams).then(res => {
                if (res.code == 405) {
                    var that = this
                    this._v_t_i = setTimeout(function () {
                        that.iswxcode()
                        clearTimeout(that._v_t_i)
                    }, 3000)
                } else if (res.code == 0) {
                    this.wxBindPop = false
                    clearTimeout(this._v_t_i)
                    localStorage.setItem('openId', res.data)
                    this.$message.success(res.msg)
                    /**
                     *  绑定成功获取用户信息
                     */
                    this.oauthapi.userInfo().then(res => {
                        localStorage.setItem('userinfo', JSON.stringify(res.data))
                        this.userinfo = res.data
                    })
                } else {
                    this.wxBindPop = false
                    clearTimeout(this._v_t_i)
                    this.$message.success(res.msg)
                }
            })
        },
        wxBindClose(done) {
            done()
            location.reload()
        },

        // 解绑微信
        unbindwx() {
            this.unbindPopXbt = '解绑社交帐号'
            this.unbindPopTxt = '解绑微信后，您将不能用微信登录笔杆论文，确定要解绑吗？'
            this.unbindPopBtn = '确认解绑'
            this.wxunbindPop = true
        },
        subunbindwx() {
            if (this.unbindPopBtn == '确认解绑') {
                this.oauthapi.unbindwechat().then(res => {
                    if (res.code == 0) {
                        this.wxunbindPop = false
                        this.$message.success(res.data)
                        /**
                         *  解绑成功获取用户信息
                         */
                        this.oauthapi.userInfo().then(res => {
                            localStorage.setItem('userinfo', JSON.stringify(res.data))
                            this.userinfo = res.data
                        })
                    }
                })
            } else if (this.unbindPopBtn == '确认注销') {
                this.wxunbindPop = false
                this.oldMobeilXbt = '验证注销账号'
                this.oldMobeilBtn = '验证账号'
                this.mobeildialog = true
            }
        },

        // 注销账号
        offUser() {
            this.businessType = 5
            this.unbindPopXbt = '验证注销账号'
            this.unbindPopTxt = '注销账号操作会删除所有账号相关信息包括论文内容、收藏记录、搜索记录、导出记录等，确认注销账号吗?'
            this.unbindPopBtn = '确认注销'
            this.wxunbindPop = true
            this.errMessage = ''
        },

        // 客服
        iskf() {
            this.iskfBox = true // 打开客服框
        },
        // 反馈图片上传成功的钩子
        feedbackSuccess(response, file, fileList) {
            this.$message({
                message: '上传成功',
                type: 'success'
            })
        },
        // 长传图片之前的钩子
        async feedbackUpload(file) {
            const isLt500K = file.size / 1024 / 1024 < 0.5
            // 不可超过500K
            if (!isLt500K) {
                this.$message.error('上传图片大小不能超过 500K!')
            } else {
                let picSuffix = {
                    picSuffix: file.name.split('.')[1] // 图片格式后缀
                }
                // 调用获取反馈图片上传oss信息接口
                // res：响应参数
                await this.oauthapi.feedbackOss(picSuffix).then(res => {
                    this.feedbackData.ossid = res.data.ossid
                    this.feedbackData.key = res.data.ossKey
                    this.feedbackData.policy = res.data.policy
                    this.feedbackData.ossAccessKeyId = res.data.ossAccessKeyId
                    this.feedbackData.signature = res.data.signature
                    this.fkParams.images = res.data.ossurl + '/' + res.data.ossKey // 反馈图片
                })
            }
            return isLt500K
        },
        feedback() {
            this.fkParams.userId = localStorage.getItem('userId')
            this.oauthapi.feedback(this.fkParams).then(res => {
                if (res.code == 0) {
                    this.iskfBox = false
                    this.fkParams.contact = ''
                    this.fkParams.content = ''
                    this.fkParams.images = ''
                    this.$message(res.msg)
                }
            })
        },
        // 微信二维码
        getContact() {
            this.oauthapi.contact().then(res => {
                this.contactList = res.data
            })
        }

    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
>>>.el-input__inner {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding-left: 10px;
}

.Account-box {
    width: 1000px;
    margin: 80px auto 150px;
}

.Account-bt {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 80px;
}

.Account-boxlist {
    overflow: hidden;

    .a-b-l {
        width: 20%;
        float: left;

        .avatar-uploader .el-upload {
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }

        .avatar {
            width: 150px;
            height: 150px;
            display: block;
        }

        .user-box-vip {
            color: #989DA2;
            font-size: 14px;
            margin-top: 10px;

            span {
                color: #C79757;
                margin-left: 10px;
                cursor: pointer;
            }
        }
    }

    .a-b-r {
        float: left;
        width: 65%;
        border-left: 2px solid #EEEEEE;
        margin-left: 50px;
        padding-left: 50px;
        font-size: 14px;

        .a-b-r-box {
            color: #333439;
            line-height: 60px;

            span {
                color: #66686E;
                display: inline-block;
                width: 100px;

                &:nth-child {
                    color: #5576BD;
                }
            }

            .b-r-box-btn {
                color: #5576BD;
                cursor: pointer;
            }

            .b-r-b-z {
                display: inline-block;
                width: 50%;
            }

            >>>.el-input {
                width: 60%;
            }
        }

        .a-b-r-btn {
            color: #FF5959;
            cursor: pointer;
        }
    }
}

.modifyM-box {
    .modifyM-box-xbt {
        text-align: center;
        font-size: 20px;
        margin-bottom: 30px;
        font-weight: bold;
    }

    .modifyM-box-txt {
        color: #66686E;
        margin-bottom: 5px;
    }

    .modifyBox-list {
        position: relative;

        .obtain {
            position: absolute;
            border: none;
            right: 0;
            background: none;
            color: $btnc;
            height: 100%;
        }
    }

    .obtain {
        position: absolute;
        border: none;
        right: 0;
        background: none;
        color: $btnc;
        height: 100%;
        top: 0;
    }

}

.ercode {
    width: 180px;
    height: 180px;
    border: 1px solid #eeeeee;
    margin: 60px auto 12px auto;
    margin-top: 60px;

    img {
        display: block;
        width: 100%;
        height: 100%;
    }
}

.kf-iconr {
    background: #5576BD;
    width: 80px;
    height: 40px;
    line-height: 40px;
    background: #5576BD;
    border-radius: 20px 0px 0px 20px;
    position: fixed;
    right: -40px;
    bottom: 40%;
    color: #fff;
    text-align: center;
    cursor: pointer;

    &:hover {
        right: 0;
    }

    img {
        vertical-align: middle;
    }

    span {
        margin-left: 5px;
    }
}

.kf-box {
    width: 340px;
    position: fixed;
    right: 0;
    bottom: 30%;
    padding: 20px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px 0px 0px 4px;
    color: #66686E;

    .kf-box-xbt {
        font-size: 16px;
        color: #333439;
        border-bottom: 1px solid #EEEEEE;
        line-height: 40px;
        margin-bottom: 10px;
    }

    .kf-box-z {
        line-height: 30px;
        cursor: pointer;

        &:nth-child(2) {
            cursor: pointer;
        }

        img {
            vertical-align: middle;
        }

        span {
            margin-left: 5px;
        }

        .wxImg {
            width: 9rem;
            height: 9rem;
            display: none;
            position: absolute;
            z-index: 2;
            margin-left: 70px;
        }

        &:hover {
            .wxImg {
                display: block;
            }
        }
    }

    .kf-box-inp {
        border: 1px solid #EEEEEE;
        border-radius: 5px;
        margin-bottom: 20px;

        .fk-con {
            >>>.el-textarea__inner {
                border: 0;
            }

            >>>.el-input__inner {
                border: 0 !important;
                width: 185%;
            }

        }

        .kf-imgs {
            position: relative;

            img {
                position: absolute;
                right: 6px;
                top: 14px;
                cursor: pointer;
            }
        }
    }

    .kf-zy {
        color: #FF5959;
        font-size: 12px;
        margin-top: 10px;
    }

    .kf-btn {
        background: #5576BD;
        width: 100px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        color: #fff;
        font-size: 18px;
        border-radius: 17px;
        margin: 15px 0 0;
        float: right;
        right: 0;
        cursor: pointer;
    }

}
</style>



// WEBPACK FOOTER //
// src/pages/Account/Account.vue